import { render, staticRenderFns } from "./edit-message-patterns.vue?vue&type=template&id=b2c50fe8&scoped=true&"
import script from "./edit-message-patterns.vue?vue&type=script&lang=js&"
export * from "./edit-message-patterns.vue?vue&type=script&lang=js&"
import style0 from "./edit-message-patterns.vue?vue&type=style&index=0&id=b2c50fe8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c50fe8",
  null
  
)

export default component.exports